import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  observer,
} from 'mobx-react';
import {
  useHistory,
} from 'react-router';
import moment from 'moment';
import {
  Button, TextField,
} from '@material-ui/core';
import {
  DatePicker,
} from '@material-ui/pickers';
import SearchFilterDropdown from '../../components/SearchFilterComponent/SearchFilterDropdown';
import {
  ConfirmationStatus,
  PaymentType,
  Transaction,
  TransactionFilterOptions,
  TransactionDue,
  TransactionStatus,
} from '../../mobx-store/storeInterfaces/transactionInterface';
import {
  stores,
} from '../../mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import classes from './styles.module.scss';
import {
  DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE,
} from '../../constants/pagination';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';

const WaterfrontTransactionsManagement: React.FC = () => {
  const {
    transactionsStore,
  } = stores;

  const history = useHistory();
  const statusFilterRef = useRef<SearchFilterDropdown>(null);
  const confirmationFilterRef = useRef<SearchFilterDropdown>(null);
  const paymentTypeFilterRef = useRef<SearchFilterDropdown>(null);

  const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);
  const [totalNumberOfPages, setTotalNumberOfPages] = useState(1);
  const defaultFilterValues = {
    filterValue: '',
    status: TransactionStatus.ALL,
    isConfirmed: ConfirmationStatus.All,
    paymentType: PaymentType.ALL,
    start: '',
    end: '',
  };

  const [filterValues, setFilterValues] = useState(defaultFilterValues);

  const getTransactions = async (clearing = false) => {
    transactionsStore.loading = true;
    if (clearing) {
      await transactionsStore.getAllTransactions({
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalNumberOfPages: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        ...defaultFilterValues,
        payableFor: TransactionDue.Waterfront,
      } as TransactionFilterOptions);
    } else {
      await transactionsStore.getAllTransactions({
        pageNumber,
        totalNumberOfPages,
        pageSize: DEFAULT_PAGE_SIZE,
        ...filterValues,
        payableFor: TransactionDue.Waterfront,
      } as TransactionFilterOptions);
    }
    transactionsStore.loading = false;
    const numberOfPages = Math.ceil(transactionsStore.transactionsCount / DEFAULT_PAGE_SIZE);
    setTotalNumberOfPages(numberOfPages);
  };

  useEffect(() => {
    getTransactions();
  }, [pageNumber]);

  const createTableHeader = () => {
    const tableHeader = [
      {
        title: 'Transaction ID',
      },
      {
        title: 'Membership ID',
      },
      {
        title: 'Status',
      },
      {
        title: 'Amount',
      },
      {
        title: 'Fawry Status',
      },
      {
        title: 'Paymob Status',
      },
      {
        title: 'Points Status',
      },
      {
        title: 'Confirmation ID',
      },
      {
        title: 'Creation Date',
      },
      {
        title: 'Payment Date',
      },
      {
        title: 'Details',
      },
    ];
    // if (authStore.userData.role.title === ROLES.SUPER_ADMIN) {
    //   tableHeader.push({
    //     title: "Cancel"
    //   });
    // }
    return tableHeader;
  };

  const getConfirmationId = (transaction: Transaction) => (
    transaction.waterFrontTransaction && transaction.waterFrontTransaction.confirmationId
      ? transaction.waterFrontTransaction.confirmationId : 'Not Confirmed'
  );

  const getTableData = () => (transactionsStore.transactionsList
    .map((transaction: any) => ({
      transactionId: transaction.transactionId,
      status: transaction.status,
      amount: transaction.amount,
      fawryTransactionStatus:
        transaction.fawryTransactions && transaction.fawryTransactions.length
          ? transaction.fawryTransactions[transaction.fawryTransactions.length - 1].status : 'Not Found',
      paymobTransactionStatus:
        transaction.paymobTransactions && transaction.paymobTransactions.length
          ? transaction.paymobTransactions[transaction.paymobTransactions.length - 1].status : 'Not Found',
      pointsTransactionStatus:
        transaction.deglawyPointsTransactions && transaction.deglawyPointsTransactions.length
          ? transaction.deglawyPointsTransactions[transaction.deglawyPointsTransactions.length - 1].status
          : 'Not Found',
      confirmationId: getConfirmationId(transaction),
      membershipId: transaction.user.membershipId,
      createdAt: moment.utc(transaction.createdAt).format('YYYY-MM-DD'),
      date: moment.utc(transaction.paymentDate).format('YYYY-MM-DD'),
      details: 'details',
    }))
  );

  const handleDetailsButtonClick = (index: number) => {
    history.push(`/transactions/waterfront/${transactionsStore.transactionsList[index].transactionId}`);
  };

  const createTableCellTypes = (): TableCellTypes[] => {
    const cellTypes: TableCellTypes[] = [
      {
        cellType: 'Text',
        key: 'transactionId',
      },
      {
        cellType: 'Text',
        key: 'membershipId',
      },
      {
        cellType: 'Text',
        key: 'status',
      },
      {
        cellType: 'Text',
        key: 'amount',
      },
      {
        cellType: 'Text',
        key: 'fawryTransactionStatus',
      },
      {
        cellType: 'Text',
        key: 'paymobTransactionStatus',
      },
      {
        cellType: 'Text',
        key: 'pointsTransactionStatus',
      },
      {
        cellType: 'Text',
        key: 'confirmationId',
      },
      {
        cellType: 'Text',
        key: 'createdAt',
      },
      {
        cellType: 'Text',
        key: 'date',
      },
      {
        cellType: 'Button',
        key: 'details',
        onClick: handleDetailsButtonClick,
      },
    ];
    // if(authStore.userData.role.title === ROLES.SUPER_ADMIN) {
    //   cellTypes.push({
    //     cellType: 'Button',
    //     key: 'cancel',
    //     onClick: this.cancelTransactionClicked,
    //     disabled: this.disableCancelButton
    //   })
    // }
    return cellTypes;
  };

  const formatDate = (date: Date) => {
    if (!date) {
      return '';
    }
    date = new Date(date);
    const formattedDate = `
      ${date.getMonth() > 8 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`}
      /${date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`}
      /${date.getFullYear()}`;
    return formattedDate;
  };

  const handleStartDateChanged = (startDate: Date) => {
    setFilterValues({
      ...filterValues,
      start: formatDate(startDate),
    });
  };

  const handleEndDateChanged = (endDate: Date) => {
    setFilterValues({
      ...filterValues,
      end: formatDate(endDate),
    });
  };

  const filter = async () => {
    const searchQuery = new URLSearchParams();
    searchQuery.append('filterValue', filterValues.filterValue);
    searchQuery.append('start', filterValues.start);
    searchQuery.append('end', filterValues.end);
    searchQuery.append('status', filterValues.status);
    searchQuery.append('isConfirmed', filterValues.isConfirmed);
    searchQuery.append('paymentType', filterValues.paymentType);
    history.push({
      pathname: '/transactions/waterfront',
      search: `?${searchQuery.toString()}`,
    });
    if (pageNumber === DEFAULT_PAGE_NUMBER) {
      await getTransactions();
    } else {
      setPageNumber(DEFAULT_PAGE_NUMBER);
    }
  };

  const getTransactionsStatus = () => ({
    value: filterValues.status,
    onChange: (newFilter: TransactionStatus) => {
      setFilterValues({
        ...filterValues,
        status: newFilter,
      });
    },
    filters: [...Object.values(TransactionStatus).map((trStatus) => ({
      value: trStatus,
      name: trStatus.charAt(0).toUpperCase() + trStatus.slice(1),
    }))],
  });

  const getConfirmationOptions = () => ({
    value: filterValues.isConfirmed,
    onChange: (newFilter: ConfirmationStatus) => {
      setFilterValues({
        ...filterValues,
        isConfirmed: newFilter,
      });
    },
    filters: [
      {
        value: 'all',
        name: 'All',
      },
      {
        value: true,
        name: 'Confirmed',
      },
      {
        value: false,
        name: 'UnConfirmed',
      },
    ],
  });

  const getPaymentTypeOptions = () => ({
    value: filterValues.paymentType,
    onChange: (newFilter: PaymentType) => {
      setFilterValues({
        ...filterValues,
        paymentType: newFilter,
      });
    },
    filters: [...Object.values(PaymentType).map((payType) => ({
      value: payType,
      name: payType.charAt(0).toUpperCase() + payType.slice(1),
    }))],
  });

  const handleClearFilter = async () => {
    history.push({
      pathname: '/transactions/waterfront',
      search: '',
    });
    setTotalNumberOfPages(1);
    setFilterValues(defaultFilterValues);
    if (pageNumber === DEFAULT_PAGE_NUMBER) {
      await getTransactions(true);
    } else {
      setPageNumber(DEFAULT_PAGE_NUMBER);
    }
    statusFilterRef.current?.setState({
      status: TransactionStatus.ALL,
    });
    confirmationFilterRef.current?.setState({
      status: ConfirmationStatus.All,
    });
    paymentTypeFilterRef.current?.setState({
      status: PaymentType.ALL,
    });
  };

  const download = async () => {
    await transactionsStore.download({
      pageNumber,
      totalNumberOfPages,
      pageSize: DEFAULT_PAGE_SIZE,
      ...filterValues,
      payableFor: TransactionDue.Waterfront,
    } as TransactionFilterOptions);
  };

  return (
    <div>
      <TextField
        className={classes.searchInput}
        placeholder="Search"
        value={filterValues.filterValue}
        label="Search"
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            filter();
          }
        }}
        onChange={(text) => {
          setFilterValues({
            ...filterValues,
            filterValue: text.target.value,
          });
        }}
      />
      <div className={classes.dateGroup}>
        <DatePicker
          variant="inline"
          className={classes.datePicker}
          label="Search By Date From"
          name="startDateSearch"
          format="dd/MM/yyyy"
          value={filterValues.start || null}
          views={['year', 'month', 'date']}
          onChange={(value) => {
            handleStartDateChanged(value as any || new Date() as any);
          }}
        />
        <DatePicker
          variant="inline"
          className={classes.datePicker}
          label="To"
          name="endDateSearch"
          format="dd/MM/yyyy"
          value={filterValues.end || null}
          views={['year', 'month', 'date']}
          onChange={(value) => {
            handleEndDateChanged(value as any || new Date() as any);
          }}
        />
      </div>
      <div className={classes.filterDropdowns}>
        <SearchFilterDropdown
          ref={statusFilterRef}
          label="Status"
          searchFilterDropdown={getTransactionsStatus()}
        />
        <SearchFilterDropdown
          ref={confirmationFilterRef}
          label="Confirmation Status"
          searchFilterDropdown={getConfirmationOptions()}
        />
        <SearchFilterDropdown
          ref={paymentTypeFilterRef}
          label="Payment Type"
          searchFilterDropdown={getPaymentTypeOptions()}
        />
      </div>
      <div className={classes.filterButtons}>
        <Button
          onClick={filter}
          color="primary"
          variant="contained"
        >
          Filter
        </Button>
        <Button
          onClick={handleClearFilter}
          color="primary"
          variant="contained"
        >
          Clear
        </Button>
        <div className={classes.downloadBtn}>
          <Button
            onClick={download}
            color="primary"
            variant="contained"
          >
            Download
          </Button>
        </div>
      </div>
      <GeneralTableComponent
        emptyMessage="No Transactions Found"
        tableHeader={createTableHeader()}
        tableData={getTableData()}
        tableCellTypes={createTableCellTypes()}
        loading={transactionsStore.loading}
        hadPagination
        paginationAction={{
          handleClickLeftArrow: () => setPageNumber(pageNumber - 1),
          handleClickRightArrow: () => setPageNumber(pageNumber + 1),
          pageNumber,
          totalNumberOfPages,
        }}
      />
    </div>
  );
};

export default observer(WaterfrontTransactionsManagement);
